/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { withRouter } from 'react-router';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  GetAndDispatchPriceTypeDetails,
  setPriceTypeDataChangeTried,
  updatePriceTypeDetails,
  resetPriceTypeStore,
} from '../store/action';
import PriceTypeTable from './PriceTypeTable';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { isReadOnly as isRead } from '../../../../SharedModules/utilities/utilities';

function PriceType({ location }) {
  const dispatch = useDispatch();
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState)?.readOnly || false;
  }
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const rebatePriceSerchResult = useSelector(
    (state) => state?.sharedState?.PriceTypeReducer?.rebatePriceSerchResult
  );
  const compareRebatePriceSerchResult = useSelector(
    (state) =>
      state?.sharedState?.PriceTypeReducer?.compareRebatePriceSerchResult
  );

  const dataChangeTried = useSelector(
    (state) => state?.sharedState?.PriceTypeReducer?.dataChangeTried
  );

  const errorMessage = useSelector(
    (state) => state?.sharedState?.PriceTypeReducer?.errorMessage
  );

  const successMessages = useSelector(
    (state) => state?.sharedState?.PriceTypeReducer?.successMessages
  );

  const loading = useSelector(
    (state) => state?.sharedState?.PriceTypeReducer?.loading
  );

  const [disableSaveAndCancel, setDisableSaveAndCancel] = useState(true);
  const [actionModal, setActionModal] = useState({ open: false, type: null });
  const [fullScreen, setFullScreen] = useState(false);
  const [willCloseTab, setWillCloseTab] = useState(false);
  const history = useHistory();

  const openActionModal = (type) => {
    setActionModal({ open: true, type });
  };

  const handleActionModalClose = () => {
    setActionModal({ open: false, type: null });
  };

  const handleCancel = () => {
    dispatch(
      GetAndDispatchPriceTypeDetails(() => {
        handleActionModalClose();
        dispatch(setPriceTypeDataChangeTried(Math.random()));
      })
    );
  };

  const handleSave = () => {
    const saveData = _.differenceWith(
      rebatePriceSerchResult,
      compareRebatePriceSerchResult,
      _.isEqual
    );

    const apiData = saveData.map(({ index, ...rest }) => {
      return { ...rest, lastUpdateUserId: logInUser };
    });

    dispatch(
      updatePriceTypeDetails({ priceTypeList: apiData }, () => {
        handleActionModalClose();
        dispatch(setPriceTypeDataChangeTried(Math.random()));
      })
    );
  };

  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/priceType' && !disableSaveAndCancel) {
          item.isFormDirty = true;
          if (errorMessage) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (item.navTo === '/priceType') {
          item.isFormDirty = false;
          if (!errorMessage) {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [disableSaveAndCancel, errorMessage]);

  useEffect(() => {
    if (
      rebatePriceSerchResult.length === 0 ||
      _.isEqual(rebatePriceSerchResult, compareRebatePriceSerchResult)
    ) {
      dispatch(GetAndDispatchPriceTypeDetails());
    }
    handleScrollToEvent();
  }, []);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/priceType' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/priceType' && item.isFormSave) {
          item.isFormSave = false;
          if (!errorMessage) {
            setWillCloseTab(true);
            handleSave();
          }
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  useEffect(() => {
    validateBtnDisable();
    if (willCloseTab) {
      closeTab('/priceType', history, dispatch);
      dispatch(resetPriceTypeStore());
    }
  }, [dataChangeTried]);

  const validateBtnDisable = () => {
    if (_.isEqual(rebatePriceSerchResult, compareRebatePriceSerchResult)) {
      setDisableSaveAndCancel(true);
    } else {
      setDisableSaveAndCancel(false);
    }
  };

  return (
    <div className="tabs-container code-table custom-check">
      {loading && <Spinner load={loading} />}
      {successMessages && (
        <DisplaySuccessMessages successMessages={[successMessages]} />
      )}
      {errorMessage && <DisplayErrorMessages errorMessages={[errorMessage]} />}
      <CustomSeparator parent1="System" parent2="Price Type" />

      {!fullScreen && (
        <div className="d-flex justify-content-end align-items-center btn-wrapper mt-3 mb-5">
          <Button
            className="btn btn-success btn-search"
            onClick={() => openActionModal('Save')}
            disabled={isReadOnly || disableSaveAndCancel}
          >
            <SVGComponent iconName="Icon-awesome-save" />
            Save
          </Button>
          <Button
            onClick={() => openActionModal('Cancel')}
            className="btn btn-cancel btn btn-primary"
            disabled={isReadOnly || disableSaveAndCancel}
          >
            <SVGComponent iconName="Icon-cancel" />
            Cancel
          </Button>
        </div>
      )}
      <PriceTypeTable
        rebatePriceSerchResult={rebatePriceSerchResult}
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
        isReadOnly={isReadOnly}
      />

      <SaveCancelPopup
        open={actionModal.open}
        title={actionModal.type}
        onConfim={() => {
          if (actionModal.type === 'Save') {
            handleSave();
          } else {
            handleCancel();
          }
        }}
        onCancel={handleActionModalClose}
        moduleName=""
      />
    </div>
  );
}
export default withRouter(PriceType);
